import { ContactSortField, SortDirection } from "@/components/screens/Contacts/types";
import IContact from "@/interfaces/contact.interface";

/** Campos aceitos pelo POST /api/v1/contact/filter (sortBy no body e query). */
export const CONTACT_SORT_API_FIELD: Record<ContactSortField, string> = {
  firstName: "firstName",
  lastName: "lastName",
  email: "email",
  addressCity: "addressCity",
  addressState: "addressStateUf",
  active: "active",
  consentStatus: "consentStatus",
};

export function resolveContactSortApiField(
  sortField: ContactSortField | string | null | undefined
): string {
  if (!sortField) return CONTACT_SORT_API_FIELD.firstName;
  return CONTACT_SORT_API_FIELD[sortField as ContactSortField] ?? sortField;
}

function getConsentSortKey(contact: IContact): string {
  const status = (contact.consentStatus ?? "").trim().toLowerCase();
  const hasStatus = status.length > 0;
  const consentDate = contact.consentDate;
  const hasConsentDate =
    consentDate !== null && consentDate !== undefined && String(consentDate).trim() !== "";

  if (!hasConsentDate && !hasStatus) return "pendente";
  return status || "pendente";
}

function getContactSortValue(contact: IContact, sortField: ContactSortField): string | number {
  switch (sortField) {
    case "firstName":
      return `${contact.firstName ?? ""} ${contact.lastName ?? ""}`.trim().toLowerCase();
    case "lastName":
      return (contact.lastName ?? "").toLowerCase();
    case "email":
      return (contact.email ?? "").toLowerCase();
    case "addressCity":
      return (contact.addressCity ?? "").trim().toLowerCase();
    case "addressState":
      return (contact.addressStateUf ?? contact.addressState ?? "").trim().toLowerCase();
    case "active":
      return contact.active === false ? 0 : 1;
    case "consentStatus":
      return getConsentSortKey(contact);
    default:
      return "";
  }
}

function compareSortValues(a: string | number, b: string | number): number {
  if (typeof a === "number" && typeof b === "number") return a - b;
  return String(a).localeCompare(String(b), "pt-BR", { sensitivity: "base" });
}

/** Ordena os itens da página atual (fallback quando a API não aplica sortBy). */
export function sortContactItems(
  items: IContact[],
  sortField: ContactSortField,
  sortDirection: SortDirection
): IContact[] {
  const direction = sortDirection === "desc" ? -1 : 1;

  return [...items].sort((left, right) => {
    const comparison = compareSortValues(
      getContactSortValue(left, sortField),
      getContactSortValue(right, sortField)
    );
    if (comparison !== 0) return comparison * direction;

    return compareSortValues(
      getContactSortValue(left, "firstName"),
      getContactSortValue(right, "firstName")
    );
  });
}
